import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=496e9e29&scoped=true&"
import script from "./ModalChat.vue?vue&type=script&lang=js&"
export * from "./ModalChat.vue?vue&type=script&lang=js&"
import style0 from "./ModalChat.vue?vue&type=style&index=0&id=496e9e29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e9e29",
  null
  
)

export default component.exports